<div class="inner-content" ridangoAppTrapFocus>
    <div class="h-full w-full rounded-2xl bg-white">
        <div class="flex-align-center relative flex h-16 w-full">
            <p class="align-center flex-1 font-semibold">
                {{ 'TICKET_SUMMARY_V2_MAP_TITLE' | translate }}
            </p>
            <button
                class="!absolute !right-2 text-grey-zambezy"
                [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                (click)="cancel()"
                mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="flex-align-center !flex justify-between border-b border-solid"></div>
        <div class="zone-map-slides flex-align-center flex h-full justify-center">
            <ion-slides [options]="slideOptions" pager="true">
                <ion-slide class="content">
                    <div class="swiper-zoom-container">
                        <img
                            class="image-fit"
                            [attr.aria-label]="'AREAS_MAP_DESCRIPTION' | translate"
                            [attr.alt]="'AREAS_MAP_DESCRIPTION' | translate"
                            [src]="mapSrc$ | async"
                            ridangoTransformOverride />
                    </div>
                </ion-slide>
            </ion-slides>
        </div>
    </div>
</div>
